<template>
  <ion-page>
    <master-layout pageTitle="لیست خودروها">
      <Loading v-if="loading"></Loading>
      <div v-if="!loading">
        <div v-if="!error">
          <div class="fancy-title-wrapper search-input-area" style="padding: 0;">
            <div class="fancy-title light">
              <h1>
                {{part.title}}<br/>
                <small>{{carType.title}}</small>
              </h1>
            </div>
          </div>
          <br/>
          <div>
            <div class="car_part_pic_container center hotspot-img">
              <img class="img-fluid car_part_pic" :src="picUrl" style="width: 100%" />

              <div v-for="attr in fixedAttributes" :key="attr.id" class="hot-spot" :id="'hotspot-t_'+id" :data-x="attr.pic_x"
                   :data-y="+attr.pic_y" style="display: block;">
                <div class="circle"></div>
                <span class="caption">{{attr.pic_text}}</span>
              </div>
            </div>

            <div class="ion-padding">
              <table class="table attr-table table-bordered table-striped section-light center">
              <tbody>
              <tr v-for="(attr,index) in attributes" :key="index">
                <th class="center">{{ attr.name }}</th>
                <td class="center p-relative">
                  <span class="number-badge">{{attr.pic_text?attr.pic_text:'--'}}</span>
                    <span v-for="(value,index) in attr.value" :key="index">
                    {{ (index > 0 ? ', ' : '') }}
                      <router-link :to="'/ShopSearch/typeAttribute='+attr.id+'&'+attr.id+'Items='+attr.value_ids[index]">{{ value }}</router-link>
                    </span>
                </td>
              </tr>
              </tbody>

            </table>
            </div>
          </div>
        </div>
        <div v-if="error" class="ion-padding">
          <br/>
        <div class="alert alert-danger">{{ error }}</div>
        </div>
      </div>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonPage} from '@ionic/vue'
import {mapActions} from "vuex";
import Loading from "@/components/Loading";

export default {
  name: "models",
  data: function ()
  {
    return {
      loading: true,
      picUrl:null,
      attributes:null,
      part:null,
      carType:null,
      error: null,
      partId: null,
      carTypeId: null,
    }
  },
  mounted()
  {
    this.partId = this.$route.params.partId;
    this.carTypeId = this.$route.params.typeId;
    this.getCarPart({partId:this.partId,carTypeId:this.carTypeId}).then((result) =>
    {
      this.loading = false;
      if (result)
      {
        if (result.ok)
        {
          this.picUrl = result.picUrl;
          this.attributes = result.attributes;
          this.part = result.carPart;
          this.carType = result.carType;
          setTimeout(function (){
            require('@/shared/hotspot');
            window.$(document).ready(function ()
            {
              //rendering pre printed items
              window.$('body').hotSpot({
                selector: '.hot-spot',
              });
            });
          },100)
        }
        else
          this.error = result.error;
      }
      else
        this.error = 'لطفا از دسترسی تلفن همراه خود به اینترنت مطمئن شوید'
    })
  },
  methods: {
    ...mapActions("car", {
      getCarPart: 'getCarPart',
    })
  },
  computed:{
    fixedAttributes()
    {
      let items = [];
      if (!this.attributes)
        return [];
      for (let i=0;i<this.attributes.length;i++)
      {
        if (this.attributes[i].pic_x && this.attributes[i].pic_y)
          items.push(this.attributes[i]);
      }
      return items;
    }
  },
  components: {
    Loading,
    IonPage
  }
}
</script>

<style scoped>

.search-input-area {
  padding: 10px 15px 40px;
  background: #00295e;
}

.title h4 {
  font-size: 16px;
  height: 45px;
}
td.p-relative{
  padding-right: 20px !important;
}
.number-badge {
  background: #00295e;
  width: 30px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  border-radius: 50%;
  color: #fff;
  position: absolute;
  right: 0;
}

.hotspot-img {
  background-color: #ededed;
  background-size: cover;
  background-position: center center;
  position: relative;
  display: inline-block;
}
.hotspot-img .hot-spot {
  position: absolute;
  width: 25px;
  height: 25px;
  top: 5px;
  left: 5px;
  text-align: center;
  background-color: rgba(0, 46, 121,0.7);
  color: #fff;
  border-radius: 100%;
  cursor: pointer;
}
.hotspot-img .hot-spot .circle {
  display: block;
  position: absolute;
  top: 50%;
  left: 55%;
  width: 25px;
  height: 25px;
  margin: -1em auto auto -1em;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  border-radius: 50%;
  border: 1px solid #002E79;
  opacity: 0;
  -webkit-animation: pulsate 3s ease-out infinite;
  animation: pulsate 3s ease-out infinite;
}
.hot-spot .caption {
  position: relative;
  display: inline-block;
  top: 2px;
}
@-webkit-keyframes
pulsate {  0% {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 0.8;
}
  45% {
    -webkit-transform: scale(1.75);
    transform: scale(1.75);
    opacity: 0;
  }
}
@keyframes
pulsate {  0% {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 0.8;
}
  45% {
    -webkit-transform: scale(1.75);
    transform: scale(1.75);
    opacity: 0;
  }
}
</style>